import { UserStoreService } from '@/core/stores/user-store.service';
import { inject, Injectable } from '@angular/core';
import { UserAccountsApi } from './user-accounts-api';

@Injectable({
    providedIn: 'root'
})
export class UserAccountsService {
    userAccountsApi = inject(UserAccountsApi);
    userStore = inject(UserStoreService);

    SearchUserAccounts(search: string, page: number, pageSize: number) {
        return this.userAccountsApi.SearchUserAccounts(search, page, pageSize);
    }

    GetUserAccountById(userAccountId: string) {
        return this.userAccountsApi.GetUserAccountById(userAccountId);
    }

    UploadUserAvatar(file: File) {
        return this.userAccountsApi.UploadUserAvatar(file);
    }

    UpdateUserAccount(userAccountId: string, fullName: string, empCode: string, phone: string, email: string, departmentId: string, roleId: string, positionId: string, avatarUrl: string) {
        const updateBy = this.userStore.getUserId() ?? '';
        const updateByUserName = this.userStore.getUserName() ?? '';
        return this.userAccountsApi.UpdateUserAccount(userAccountId, fullName, empCode, phone, email, departmentId, roleId, positionId, avatarUrl, updateBy, updateByUserName);
    } 

    ImportsUserAccounts() {
        const actionBy = this.userStore.getUserId() ?? '';
        const actionUserName = this.userStore.getUserName() ?? '';
        return this.userAccountsApi.ImportsUserAccounts(actionBy, actionUserName);
    }

    CreateUserAccount(fullName: string, empCode: string, phone: string, email: string, departmentId: string, roleId: string, positionId: string, avatarUrl: string) {
        const createdBy = this.userStore.getUserId() ?? '';
        const createdByUserName = this.userStore.getUserName() ?? '';
        return this.userAccountsApi.CreateUserAccount(fullName, empCode, phone, email, departmentId, roleId, positionId, avatarUrl, createdBy, createdByUserName);
    }

    CheckUserAccountFullName(fullName: string) {
        return this.userAccountsApi.CheckUserAccountFullName(fullName);
    }

    CheckUserAccountEmpCode(empCode: string) {
        return this.userAccountsApi.CheckUserAccountEmpCode(empCode);
    }

    CheckUserAccountEmail(email: string) {
        return this.userAccountsApi.CheckUserAccountEmail(email);
    }

    UserAccountChangePassword(currentPassword: string, newPassword: string, confirmNewPassword: string) {
        const userAccountId = this.userStore.getUserId() ?? '';
        return this.userAccountsApi.UserAccountChangePassword(userAccountId, currentPassword, newPassword, confirmNewPassword);
    }

    UserAccountResetPassword(userAccountId: string) {
        const resetBy = this.userStore.getUserId() ?? '';
        const userNameResetBy = this.userStore.getUserName() ?? '';
        return this.userAccountsApi.ResetPassword(userAccountId, resetBy, userNameResetBy);
    }

    GetSelectBranchListByUserId() {
        const userId = this.userStore.getUserId() ?? '';
        return this.userAccountsApi.GetSelectBranchListByUserId(userId);
    }

}
